import React, { useState, useEffect, useRef } from 'react'
import styles from './supplier.module.scss'
import moment from 'moment'
import { compare } from 'utils'

//antd
import { DatePicker, Select, Input, Button, Table, Row, Col, notification, Popconfirm } from 'antd'

//icons
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons'

//components
import TitlePage from 'components/title-page'
import SupplierForm from './supplier-form'
import columnsSupplier from './columns'
import SettingColumns from 'components/setting-columns'

//apis
import { getSuppliers, deleteSupplier } from 'apis/supplier'

const { RangePicker } = DatePicker
export default function Supplier() {
  const typingTimeoutRef = useRef(null)

  const [columns, setColumns] = useState([])
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')
  const [valueDate, setValueDate] = useState(null)

  const [countSupplier, setCountSupplier] = useState(0)
  const [suppliers, setSuppliers] = useState([])

  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })

  function onChangeDate(dates, dateStrings) {
    setValueDate(dates)

    if (dates) {
      paramsFilter.from_date = dateStrings[0]
      paramsFilter.to_date = dateStrings[1]
    } else {
      delete paramsFilter.from_date
      delete paramsFilter.to_date
    }

    paramsFilter.page = 1
    setParamsFilter({ ...paramsFilter })
  }
  const onSearch = (e) => {
    const value = e.target.value

    setValueSearch(value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      if (value) paramsFilter.search = value
      else delete paramsFilter.search
      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _getSuppliers = async () => {
    try {
      setLoading(true)
      const res = await getSuppliers({ ...paramsFilter, _creator: true })
      console.log(res)
      if (res.status === 200) {
        setSuppliers(res.data.data)
        setCountSupplier(res.data.count)
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _deleteSupplier = async (id) => {
    try {
      setLoading(true)
      const res = await deleteSupplier(id)
      setLoading(false)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa nhà cung cấp thành công' })
          _getSuppliers()
        } else
          notification.error({
            message: res.data.message || 'Xóa nhà cung cấp thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa nhà cung cấp thất bại, vui lòng thử lại',
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const onClickClear = () => {
    setValueSearch('')
    setValueDate(null)

    setParamsFilter({ page: 1, page_size: 20 })
  }

  useEffect(() => {
    _getSuppliers()
  }, [paramsFilter])

  return (
    <div className={`${styles['supplier_manager']} ${styles['card']}`}>
      <TitlePage title="Quản lý nhà cung cấp">
        <SupplierForm reloadData={_getSuppliers}>
          <Button size="large" type="primary" icon={<PlusCircleOutlined />}>
            Thêm nhà cung cấp
          </Button>
        </SupplierForm>
      </TitlePage>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={8}>
          <Input
            size="large"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo mã, theo tên"
            allowClear
          />
        </Col>

        <Col xs={24} sm={24} md={11} lg={11} xl={8}>
          <RangePicker
            size="large"
            className="br-15__date-picker"
            style={{ width: '100%' }}
            value={valueDate}
            ranges={{
              Today: [moment(), moment()],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
            }}
            onChange={onChangeDate}
          />
        </Col>
        <Col style={{ display: Object.keys(paramsFilter).length < 3 && 'none' }}>
          <Button onClick={onClickClear} type="primary" size="large">
            Xóa tất cả lọc
          </Button>
        </Col>
      </Row>
      <Row justify="end" style={{ marginTop: 10 }}>
        <SettingColumns
          nameColumn="columnsSupplier"
          columns={columns}
          setColumns={setColumns}
          columnsDefault={columnsSupplier}
        />
      </Row>
      <Table
        style={{ marginTop: 5, width: '100%' }}
        size="small"
        rowKey="_id"
        // rowSelection={rowSelection}
        columns={columns.map((column) => {
          if (column.key === 'stt') return { ...column, render: (text, record, index) => index + 1 }
          if (column.key === 'code')
            return {
              ...column,
              render: (text, record) => (
                <SupplierForm reloadData={_getSuppliers} record={record}>
                  <a>{text}</a>
                </SupplierForm>
              ),
              sorter: (a, b) => compare(a, b, 'code'),
            }
          if (column.key === 'name') return { ...column, sorter: (a, b) => compare(a, b, 'name') }
          if (column.key === 'create_date')
            return {
              ...column,
              render: (text, record) => (text ? moment(text).format('YYYY-MM-DD HH:mm') : ''),
              sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
            }
          if (column.key === 'email') return { ...column, sorter: (a, b) => compare(a, b, 'email') }
          if (column.key === 'phone') return { ...column, sorter: (a, b) => compare(a, b, 'phone') }
          if (column.key === 'address')
            return {
              ...column,
              render: (text, record) =>
                `${record.address && record.address + ', '}${
                  record.district && record.district + ', '
                }${record.province && record.province}`,
            }
          if (column.key === 'action')
            return {
              ...column,
              render: (text, record) => (
                <Popconfirm
                  onConfirm={() => _deleteSupplier(record.supplier_id)}
                  title="Bạn có muốn xóa nhà cung cấp này không?"
                >
                  <DeleteOutlined style={{ color: 'red', fontSize: 19, cursor: 'pointer' }} />
                </Popconfirm>
              ),
            }

          return column
        })}
        dataSource={suppliers}
        loading={loading}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) => {
            paramsFilter.page = page
            paramsFilter.page_size = pageSize
            setParamsFilter({ ...paramsFilter })
          },
          total: countSupplier,
        }}
      />
    </div>
  )
}
